import styled from "styled-components/macro";

export const PatientContainer = styled.div`
  height: 7%;
  grid-area: patient;
  color: #caceca;
  display: flex;
  background: var(--clr-darkgray);
  justify-content: space-between;
  padding: 0 0.2em;
  align-items: center;
`;

export const BedNumber = styled.div`
`;

export const PatientName = styled.div``;
export const Flex = styled.div`
  display: flex;
  gap: 0.2em;
  align-items: center;
`;


export const IconWrapper = styled.div`
  margin-top: 3.5px;
`; 